import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { getProgress } from '@/components/Card/Card.helpers';
import { Typography } from '@/components/ui/Typography/Typography.styles';
import { CardAd } from '@/types';

import * as S from './Card.styles';

interface ProgressBarProps {
  daysLeft: CardAd['daysLeft'];
}

export const ProgressBar: FC<ProgressBarProps> = ({ daysLeft }) => {
  const { t } = useTranslation();

  return (
    <S.ProgressBarWrapper>
      <Typography variant="caption3">
        {t('Card.days_left', { count: daysLeft ?? 0 })}
      </Typography>
      <S.ProgressBar $progress={getProgress(daysLeft ?? 0)} />
    </S.ProgressBarWrapper>
  );
};
